// Western Michigan University's undergraduate majors (#2748). Read on
// 2026-10-01 from WMU's official Undergraduate Programs list
// (wmich.edu/academics/undergraduate, A to Z, each program with its degree:
// BA, BS, BBA, BSE, BFA, BM, BMA, BSN, BSW), every bachelor's line kept;
// certificates, the pre-BBA and pre-professional tracks and the exploratory
// curriculum left out. A program with two degrees (Art, BA and BFA) is one
// line per degree. Colleges come from each college's own program page: Arts
// and Sciences, Aviation, Haworth (business), Education and Human
// Development, Engineering and Applied Sciences, Health and Human Services,
// and Merze Tate College (University Studies). The College of Fine Arts'
// academics page returned no list, so its group (art, dance, music,
// theatre, and the Richmond Institute's Product Design and Interior
// Architecture and Design, named on its admission page) cites the A to Z
// list. Cybersecurity is listed by both Engineering and Haworth and appears
// in both groups. The undergraduate catalog (catalog.wmich.edu, 2026-27)
// answered with a bot challenge, so the programs list is the official
// source used. The list writes "Biochemistr y"; it is "Biochemistry" here.
// The KB's majors list was the starting point; the school's list wins.
const majors = {
    "slug": "western-michigan-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major on WMU's official undergraduate programs list, grouped by the college that offers it, with the degree it leads to. Minors, certificates, pre-professional tracks and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "WMU College of Arts and Sciences, Academic Programs",
                "url": "https://wmich.edu/arts-sciences/academics"
            },
            "majors": [
                {
                    "name": "African American and African Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Business-Oriented Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Community and Regional Planning",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice Studies",
                    "degree": "BA"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Digital Media and Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Earth Science",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "English: Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "English: Literature and Language",
                    "degree": "BA"
                },
                {
                    "name": "English: Rhetoric and Writing Studies",
                    "degree": "BA"
                },
                {
                    "name": "Environmental and Sustainability Studies",
                    "degree": "BA"
                },
                {
                    "name": "Environmental and Sustainability Studies",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Geography",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Geology",
                    "degree": "BS"
                },
                {
                    "name": "Film, Video and Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Freshwater Science and Sustainability",
                    "degree": "BS"
                },
                {
                    "name": "Gender and Women's Studies",
                    "degree": "BA"
                },
                {
                    "name": "Geochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Geographic Information Science",
                    "degree": "BS"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "Geophysics",
                    "degree": "BS"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Global and International Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Hydrogeology",
                    "degree": "BS"
                },
                {
                    "name": "Integrated Science",
                    "degree": "BS"
                },
                {
                    "name": "Interpersonal Communication",
                    "degree": "BA"
                },
                {
                    "name": "Japanese",
                    "degree": "BA"
                },
                {
                    "name": "Latin",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Public and Nonprofit Administration",
                    "degree": "BS"
                },
                {
                    "name": "Public History",
                    "degree": "BA"
                },
                {
                    "name": "Social Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Social Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Strategic Communication",
                    "degree": "BA"
                },
                {
                    "name": "Teaching and Learning Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Teaching and Learning Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Tourism and Travel",
                    "degree": "BA"
                },
                {
                    "name": "Urban, Regional and Environmental Planning",
                    "degree": "BS"
                },
                {
                    "name": "World Religions and Cultures",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Aviation",
            "source": {
                "label": "WMU College of Aviation, Academics",
                "url": "https://wmich.edu/aviation/academics"
            },
            "majors": [
                {
                    "name": "Aviation Flight Science",
                    "degree": "BS"
                },
                {
                    "name": "Aviation Management and Operations",
                    "degree": "BS"
                },
                {
                    "name": "Aviation Technical Operations",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Education and Human Development",
            "source": {
                "label": "WMU College of Education and Human Development, Undergraduate Programs",
                "url": "https://wmich.edu/education/academics/undergraduate"
            },
            "majors": [
                {
                    "name": "Business Education",
                    "degree": "BS"
                },
                {
                    "name": "Child Development and Services",
                    "degree": "BS"
                },
                {
                    "name": "Early Childhood General and Special Education: Birth through Kindergarten",
                    "degree": "BS"
                },
                {
                    "name": "Early Childhood General and Special Education and Lower Elementary",
                    "degree": "BS"
                },
                {
                    "name": "Education and Human Development",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education PK-3 and Teaching English to Speakers of Other Languages (TESOL) K-12",
                    "degree": "BS"
                },
                {
                    "name": "Event Management",
                    "degree": "BS"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Family and Consumer Sciences Teacher Education",
                    "degree": "BS"
                },
                {
                    "name": "Fashion Design and Development",
                    "degree": "BS"
                },
                {
                    "name": "Fashion Merchandising",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Technology Education",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition and Dietetics",
                    "degree": "BS"
                },
                {
                    "name": "Occupational Education Studies",
                    "degree": "BS"
                },
                {
                    "name": "Physical and Health Education Teacher Education: K-12",
                    "degree": "BS"
                },
                {
                    "name": "Recreation Management",
                    "degree": "BS"
                },
                {
                    "name": "Special Education Learning Disabilities K-12 and Elementary Education PK-3",
                    "degree": "BS"
                },
                {
                    "name": "Sport Management",
                    "degree": "BS"
                },
                {
                    "name": "Workforce Education and Development",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Engineering and Applied Sciences",
            "source": {
                "label": "WMU College of Engineering and Applied Sciences, Academics",
                "url": "https://wmich.edu/engineer/academics"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Construction Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS",
                    "note": "Listed by both the College of Engineering and Applied Sciences and the Haworth College of Business."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Engineering Design Technology",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Management Technology",
                    "degree": "BS"
                },
                {
                    "name": "Industrial and Entrepreneurial Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Manufacturing Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Paper Engineering",
                    "degree": "BSE"
                }
            ]
        },
        {
            "name": "College of Fine Arts",
            "source": {
                "label": "WMU Undergraduate Programs (A to Z)",
                "url": "https://wmich.edu/academics/undergraduate"
            },
            "majors": [
                {
                    "name": "Acting",
                    "degree": "BFA"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Art Education",
                    "degree": "BFA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Art: Kinetic Imaging",
                    "degree": "BS"
                },
                {
                    "name": "Arts Administration",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "Interior Architecture and Design",
                    "degree": "BS"
                },
                {
                    "name": "Multimedia Arts Technology - Music",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music Composition",
                    "degree": "BM"
                },
                {
                    "name": "Music Education: Choral/General",
                    "degree": "BM"
                },
                {
                    "name": "Music Education: Instrumental",
                    "degree": "BM"
                },
                {
                    "name": "Music Performance: Instrumental",
                    "degree": "BM"
                },
                {
                    "name": "Music Performance: Keyboard",
                    "degree": "BM"
                },
                {
                    "name": "Music Performance: Vocal",
                    "degree": "BM"
                },
                {
                    "name": "Music Therapy",
                    "degree": "BM"
                },
                {
                    "name": "Music: Jazz Studies",
                    "degree": "BM"
                },
                {
                    "name": "Musical Arts",
                    "degree": "BMA"
                },
                {
                    "name": "Product Design",
                    "degree": "BFA"
                },
                {
                    "name": "Stage Management",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre Design and Technical Production",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre: Music Theatre Performance",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "College of Health and Human Services",
            "source": {
                "label": "WMU College of Health and Human Services, Academic Programs",
                "url": "https://wmich.edu/hhs/academics"
            },
            "majors": [
                {
                    "name": "Health Administration",
                    "degree": "BS"
                },
                {
                    "name": "Healthcare Services and Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Healthcare Services and Sciences Clinical Practice in Health",
                    "degree": "BS"
                },
                {
                    "name": "Healthcare Services and Sciences Physician Assistant Preparation",
                    "degree": "BS"
                },
                {
                    "name": "Healthcare Services and Rehabilitation Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Occupational Therapy Assistant",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                },
                {
                    "name": "Speech, Language and Hearing Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Haworth College of Business",
            "source": {
                "label": "WMU Haworth College of Business, Academics",
                "url": "https://wmich.edu/business/academics"
            },
            "majors": [
                {
                    "name": "Accountancy",
                    "degree": "BBA"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BBA"
                },
                {
                    "name": "Business Law",
                    "degree": "BBA"
                },
                {
                    "name": "Computer Information Systems",
                    "degree": "BBA"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS",
                    "note": "Listed by both the College of Engineering and Applied Sciences and the Haworth College of Business."
                },
                {
                    "name": "Digital Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Economics in Business",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Food Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Human Resource Management",
                    "degree": "BBA"
                },
                {
                    "name": "Integrated Business Administration",
                    "degree": "BBA"
                },
                {
                    "name": "Leadership and Business Strategy",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Personal Financial Planning",
                    "degree": "BBA"
                },
                {
                    "name": "Sales and Business Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "Merze Tate College",
            "source": {
                "label": "WMU Merze Tate College, University Studies",
                "url": "https://wmich.edu/academics/undergraduate/general"
            },
            "majors": [
                {
                    "name": "University Studies",
                    "degree": "BA"
                },
                {
                    "name": "University Studies",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
